import { render, staticRenderFns } from "./EditorProfileDeleteModal.vue?vue&type=template&id=dad254fc&scoped=true&"
import script from "./EditorProfileDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./EditorProfileDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad254fc",
  null
  
)

export default component.exports